import { styled } from '@linaria/react';
import { bodyFont, fonts, semantic, size, space } from '../../theme/tokens';

export const Row = styled.button<{ $selected: boolean }>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: ${space['space-500']};
  width: 100%;
  padding: ${space['space-500']};
  border: ${({ $selected }) =>
      $selected ? size.stroke['stroke-thick'] : size.stroke['stroke-default']}
    solid ${({ $selected }) => ($selected ? semantic.border.selected : semantic.border.default)};
  border-radius: ${size.radius['radius-lg']};
  background: ${semantic.bg.canvas};
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    border-color: ${semantic.border.selected};
  }
`;

export const Info = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['space-100']};
`;

export const RowLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  text-align: left;
`;

export const RowSublabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const Indicator = styled.span<{ $selected: boolean }>`
  box-sizing: border-box;
  width: ${size.icon['icon-md']};
  height: ${size.icon['icon-md']};
  border-radius: ${size.radius['radius-full']};
  border: ${size.stroke['stroke-default']} solid
    ${({ $selected }) => ($selected ? semantic.border.selected : semantic.border.secondary)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: transparent;
  transition: border-color 0.15s ease;

  &::after {
    content: '';
    display: ${({ $selected }) => ($selected ? 'block' : 'none')};
    width: 14px;
    height: 14px;
    border-radius: ${size.radius['radius-full']};
    background: ${semantic.bg.primary};
  }
`;
